import { FC } from 'react';

import { useOnContentImpression } from '@/scenarios/legacy-player/hooks/useOnContentImpression';
import { useOnDurationChanged } from '@/scenarios/legacy-player/hooks/useOnDurationChanged';
import { useOnFinish } from '@/scenarios/legacy-player/hooks/useOnFinish';
import { useOnReady } from '@/scenarios/legacy-player/hooks/useOnReady';
import { useSetNativeSubtitlesVisibility } from '@/scenarios/legacy-player/hooks/useSetNativeSubtitlesVisibility';

import { useKeepOnAir } from '../../hooks/use-keep-on-air';
import { hidePlayerIframeToScreenReaders } from '../../../feature-player/utils/hide-player-iframe-to-screen-readers';
import { useSoundPreferencesWatcher } from '../../../feature-player/hooks/config/use-sound-preferences';
import { useOnError } from '../../../feature-player/hooks/controller/use-on-error';
import { useLiveActiveTabController } from '../../hooks/use-live-active-tab-controller';
import { PlayerApiError } from '../../../../types/error';

interface ChannelPlayerControllerProps {
    onContentImpression: () => void;
    onFinish?: () => void;
    onError?: (error: PlayerApiError) => void;
    onDurationChanged: (duration: number) => void;
}

export const ChannelPlayerController: FC<ChannelPlayerControllerProps> = ({
    onContentImpression,
    onFinish,
    onError,
    onDurationChanged,
}) => {
    useOnContentImpression(onContentImpression);
    useOnDurationChanged(onDurationChanged);
    useOnError(onError);
    useOnFinish(onFinish);
    useOnReady(hidePlayerIframeToScreenReaders);

    useSetNativeSubtitlesVisibility(false);
    useKeepOnAir();
    useLiveActiveTabController();

    useSoundPreferencesWatcher();

    return null;
};
